import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

export default {
  async getAll($, projectId) {
    const path = `/projects/${projectId}/pcq-liner`
    let results = (await HTTP.get(path)).data
    // results.sort((a, b) => {
    //   return a.name.localeCompare(b.name)
    // })
    return results
  },

  async get(actionId) {
    const path = `/projects/pcq-liner/${actionId}`
    return (await HTTP.get(path)).data
  },

  async post(projectId, notification_object) {
    return new Promise((resolve, reject) => {
      HTTP.post(`projects/${projectId}/pcq-liner`, notification_object)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async duplicate(pcqId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`projects/pcq-liner/${pcqId}/duplicate`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },
  async revise(pcqId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`projects/pcq-liner/${pcqId}/revise`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/projects/pcq-liner/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(actionId) {
    const path = `/projects/pcq-liner/${actionId}`
    return (await HTTP.delete(path)).data
  }
}
